import React from 'react';
import Card, { CardContent } from '../ui/Card';

/*
 * 미션과 핵심가치 — 메인 4번 섹션과 회사소개(/about)가 같은 모양으로 쓴다(MissionSection).
 * 문구를 여기서 고치면 두 곳이 같이 바뀐다.
 */
const VALUES = [
    { title: '합리적 비용', lines: ['필요한 만큼만, 합리적인 가격에.', '도입 후 유지비는 0원입니다.'] },
    { title: '쉬운 사용성', lines: ['네트워크도, 개발도 몰라도 됩니다.', '5분이면 누구나 씁니다.'] },
    { title: '고객가치중심', lines: ['모든 시작은 고객의 현장입니다.', '전담 매니저가 끝까지 책임집니다.'] },
];

const MissionValues = () => (
    <>
        <div className="text-center mb-14 px-2">
            <p className="text-3xl/snug md:text-4xl/snug font-bold text-primary-500 break-keep">
                "기술의 혜택, 규모에 상관없이 누려야 하니까."
            </p>
            <p className="mt-6 text-lg md:text-xl text-gray-700 leading-relaxed break-keep">
                단 1개를 도입하는 현장도 부담 없이 시작하고,<br className="hidden md:block" />{' '}
                바로 운영할 수 있게 합니다.
            </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {VALUES.map(({ title, lines }) => (
                <Card key={title} className="hover:-translate-y-2 transition-transform duration-300">
                    <CardContent className="p-9 text-center">
                        <h3 className="text-2xl font-bold text-primary-500 mb-4">{title}</h3>
                        <p className="text-gray-600 leading-relaxed break-keep">
                            {lines[0]}<br />{lines[1]}
                        </p>
                    </CardContent>
                </Card>
            ))}
        </div>

        {/* 창업 때부터 지켜 온 슬로건. 세 가치가 이 문장을 풀어 쓴 것이다. */}
        <p className="mt-12 text-center text-sm md:text-base font-bold tracking-wide text-gray-500 break-keep">
            기술은 쉽게, 비용은 가볍게, 성과는 확실하게
        </p>
    </>
);

/** 흰 띠 + 제목까지 포함한 섹션 한 덩어리. 메인과 회사소개가 똑같이 보이도록 이것을 쓴다. */
export const MissionSection = ({ id }) => (
    <section id={id} className="scroll-mt-24 bg-white border-y border-gray-100 py-20 md:py-24 px-6">
        <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">미션과 핵심가치</h2>
            <MissionValues />
        </div>
    </section>
);

export default MissionValues;
